module.exports = __webpack_public_path__ + "static/1184835694.c02ab80c.jpg";